import React from "react";
import Footer from "../components/utils/Footer";
import Carousel from "../components/carousel/Carousel";
import embroideryList from "../components/carousel/embroideryList";
import ServiceDescription from "../components/utils/ServiceDescription";
import CallToAction from "../components/utils/CallToAction";
import PhotoGrid from "../components/utils/PhotoGrid";
import Faq from "../components/faq/Faq";
import embroideryFaq from "../components/faq/embroideryFaq";
import NavBar from "../components/utils/NavBar";
const Embroidery = () => {
  function importAll(r) {
    let images = {};
    r.keys().forEach((item, index) => {
      images[item.replace("./", "")] = r(item);
    });
    return images;
  }
  const imageList = importAll(
    require.context(
      "../images/examples/embroidery",
      false,
      /\.(png|jpe?g|JPG|svg)$/
    )
  );
  return (
    <div className="h-[calc(100dvh)] bg-black w-screen antialiased overscroll-contain overflow-x-hidden ">
      <NavBar />
      <ServiceDescription
        title={"EMBROIDERY"}
        content={`
Embroidery takes center stage as a timeless craft with its meticulous attention to detail, transforming standard garments into custom pieces. Whether creating custom designs or adding a personal touch, embroidery remains the preferred finishing technique for achieving a polished and professional appearance.

`}
      />
      <Carousel
        CarouselTitle={"What We Can Do For You."}
        breakPoint={"lg:justify-center"}
        CarouselCardList={embroideryList}
      />

      <PhotoGrid imageList={imageList} />
      <CallToAction />
      <Faq questionsList={embroideryFaq} />
      <Footer />
    </div>
  );
};

export default Embroidery;
